import {useState, useCallback, useEffect} from "react"
import qs from 'qs'
import {useHistory, useLocation} from 'react-router-dom'

function useQueryString(key, initialValue) {
  const location = useLocation()
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  const [value, setValue] = useState(query[key] || initialValue);
  const history = useHistory()
  const onSetValue = useCallback(
    newValue => {
      setValue(newValue);

      query[key] = `${newValue}`
      history.replace({ search: qs.stringify(query) })
      // setQueryStringValue(key, newValue);
    },
    [history, key, query]
  );

  useEffect(() => {
    onSetValue(query[key] || initialValue)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query[key]])

  return [value, onSetValue];
}

export default useQueryString;
